import axios from "axios";

export const submitAnswers = async (answers) => {
  const accessToken = localStorage.getItem("@user");
  const url = "https://htprdapi.hightable.ai/users/submit-answers";

  try {
    const response = await axios.post(url, answers, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error submitting answers:", error);
    throw new Error(
      error.response
        ? `Failed to submit answers: ${error.response.data}`
        : error.message
    );
  }
};
